import React from 'react';
import './styles.css';

const SelectButton = ({
  content, disabled, selected, onClick, containsDetails,
  numberOfSelectedItems, detailsOnClick,
}) => (
  <div className="select-button">
    <button
      className={`${selected ? ' selected' : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {selected ?
        numberOfSelectedItems !== 0 ?
          <div className="oval number"><span className="number">{numberOfSelectedItems}</span></div>
        :
          <div className="oval"><span className="icon-checkmark" /></div>
      :
        null
      }
      {content}
    </button>
    {containsDetails && <button className="details-button" onClick={detailsOnClick}>Nánar</button>}
  </div>
);

SelectButton.propTypes = {
  content: React.PropTypes.any,
  disabled: React.PropTypes.bool,
  selected: React.PropTypes.bool,
  onClick: React.PropTypes.func,
  containsDetails: React.PropTypes.bool,
  numberOfSelectedItems: React.PropTypes.number,
  detailsOnClick: React.PropTypes.func,
};

SelectButton.defaultProps = {
  containsDetails: false,
  numberOfSelectedItems: 0,
};

export default SelectButton;



// WEBPACK FOOTER //
// ./src/browser/app/components/SelectButton/SelectButton.js